import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { cleanAllData } from "../../Actions/ActionCreators";
import { NavLink } from "react-router-dom";
import { version_code } from "../../component/config/config";
import { useSelector } from "react-redux";
import { db } from "../config/firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleChefNav } from "../../utility/commonFunctions";

const SideBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = (e) => {
    dispatch(cleanAllData());
    localStorage.clear();
    handleChefNav(e,"")
  };
  let { pathname } = useLocation();

  const LoginData = useSelector((state) =>
    state.login.data && state.login.data.chefDetails ? state.login.data : {}
  );

  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const chefId = LoginData?.chefDetails?._id;
  const [newMessageAlert, setNewMessageAlert] = useState(null);

  useEffect(() => {
    if (!chefId) return;

    const roomsQuery = query(
      collection(db, "rooms"),
      where("secondUserId", "==", chefId)
    );

    let roomUnsubscribe = () => {};
    const messageUnsubscribers = [];
    const roomUnreadMap = new Map();

    roomUnsubscribe = onSnapshot(
      roomsQuery,
      (roomsSnapshot) => {
        messageUnsubscribers.forEach((unsub) => unsub());
        messageUnsubscribers.length = 0;

        roomsSnapshot.forEach((roomDoc) => {
          const roomId = roomDoc.id;
          const messagesRef = collection(db, "rooms", roomId, "messages");

          const msgUnsub = onSnapshot(
            messagesRef,
            async (messagesSnapshot) => {
              let unreadCount = 0;

              messagesSnapshot.forEach((msgDoc) => {
                const msg = msgDoc.data();
                if (
                  !msg.isSeen &&
                  msg.receiverId === chefId &&
                  !msg?.isRestricted
                ) {
                  unreadCount++;
                }
              });

              roomUnreadMap.set(roomId, unreadCount);

              const totalUnread = [...roomUnreadMap.values()].reduce(
                (sum, val) => sum + val,
                0
              );
              setUnreadMessageCount(totalUnread);

              const updatePromises = messagesSnapshot
                .docChanges()
                .filter(
                  (change) =>
                    change.type === "modified" &&
                    change.doc.data().isNotification &&
                    !change.doc.data().isSecondNotification &&
                    change.doc.data().senderId !== chefId
                )
                .map((change) => {
                  const msgDoc = change.doc;
                  const msgData = msgDoc.data();
                  const roomData = roomDoc.data();
                  const senderName =
                    msgData.senderName || roomData.firstUserName || "Unknown";

                  setNewMessageAlert({
                    senderName: senderName,
                    message: msgData.message,
                  });

                  return updateDoc(msgDoc.ref, {
                    isSecondNotification: true,
                  }).catch((error) => {
                    new Error(
                      "Error updating message for second notification: " +
                      error
                    );
                  });
                });

              try {
                await Promise.all(updatePromises);
              } catch (error) {
                new Error(
                  "One or more updates failed for second notification : " +
                  error
                );
              }
            },
            (error) => {
              new Error(
                "Error fetching messages: " +
                error
              );      
            }
          );

          messageUnsubscribers.push(msgUnsub);
        });
      },
      (error) => {
        new Error(
          "Error fetching rooms: " +
          error
        );
      }
    );

    return () => {
      roomUnsubscribe();
      messageUnsubscribers.forEach((unsub) => unsub());
      roomUnreadMap.clear();
    };
  }, [chefId]);

  useEffect(() => {
    if (newMessageAlert) {
      if (pathname !== "/dashboard/mychats") {
        const senderName = newMessageAlert.senderName || "Unknown";
        toast(
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  color: "hotpink",
                  marginRight: "5px",
                  fontSize: "1.5em",
                }}
              >
                <i
                  className="ri-message-2-line"
                  style={{ fontSize: "2.1rem" }}
                ></i>
              </span>
              <div>
                <b>New Message Alert</b>
                <br />
                {senderName}: {newMessageAlert.message}
              </div>
            </div>
          </>,
          {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
            progressClassName: "custom-progress-bar",
          }
        );
      }
      setNewMessageAlert(null);
    }
  }, [newMessageAlert, pathname]);

  const handleChatsClick = (e) => {
    e.preventDefault();
    navigate("/dashboard/mychats", {
      state: { userId: LoginData.chefDetails._id },
    });
  };

  return (
    <>
      <div className="sidebar-L">
        <ul>
          <li>
            <NavLink to="/">
              <i className=" ri-dashboard-line"></i> Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink to="myorder/open">
              <i className="ri-shopping-cart-line"></i>My Orders
            </NavLink>
          </li>
          <li>
            <NavLink to="mymenu/all">
              <i className="ri-file-list-3-line"></i>My Menu
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/myearnings">
              <i className="ri-money-dollar-box-line"></i>My Earnings
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/myreviews">
              <i className="ri-star-smile-line"></i>My Reviews
            </NavLink>
          </li>
          <li className="unread-countbox">
            <NavLink to="/dashboard/mychats" onClick={handleChatsClick}>
              <i className="ri-message-2-line"></i>My Messages
              {unreadMessageCount > 0 && (
                <span className="unread-count">{unreadMessageCount}</span>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="cheffaq">
              <i className="ri-questionnaire-line"></i>Help Center
            </NavLink>
          </li>
          <li>
            <NavLink to="settings">
              <i className="ri-settings-2-line"></i>Settings
            </NavLink>
          </li>
          <li onClick={(e) => logout(e)}>
            <a>
              <i className="ri-logout-box-line"></i> Logout
            </a>
          </li>
        </ul>
        <span className="versioncode">v{version_code}</span>
      </div>
    </>
  );
};

export default SideBar;
